<template>
<div>
    <div class="row" v-if="$gate.isAdmin()">
        <div class="col-md-12">
            <table class="table table-bordered table-condensed">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Role</th>
                        <th>Email</th>
                        <th>Created At</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user in users" :key="user.id">
                        <td> {{user.first_name}} {{user.last_name}} </td>
                        <td> {{user.Role}} </td>
                        <td> {{user.email}} </td>
                        <td> {{user.created_at}} </td>
                        <td>
                            <Edit :user="user" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="row" v-else>
        <notfound></notfound>
    </div>
</div>
</template>

<script>
import Edit from './edit.vue'
export default {
    components: {
        Edit
    },
    data() {
        return {
            users: [],
        }
    },
    created() {
        this.getUsers()
    },
    methods: {
        getUsers(){
            axios
            .get('./api/Admin/Users')
            .then((result) => {
                console.log(result)
                this.users = result.data
            }).catch((err) => {
                console.log(err)
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/Others/Admin/Users.vue